var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpertise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 74,
    viewBox: "0 0 70 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.3633V7.60461C1 3.95597 2.83607 0.998622 5.10144 0.998622H50.3863C52.6515 0.998622 54.5 2.3494 54.5 5.99805",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4874 46.9907V68.9028C54.4874 71.1668 52.652 73.002 50.3878 73.002H5.12306C2.85869 73.002 1.02344 71.1668 1.02344 68.9028V14.0779",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.159 21.3326L23.1883 22.0467C21.6005 22.6224 20.4341 23.9922 20.1156 25.65L19.6895 27.8819C19.3725 29.531 20.6377 31.0605 22.3174 31.0605H27.7854H33.1909C34.8576 31.0605 36.12 29.5542 35.8262 27.9139L35.4292 25.6949C35.1282 24.011 33.9531 22.6166 32.346 22.0335L30.2999 21.2919",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2311 18.5704H30.2971V21.2925V22.0151V22.0167C28.8239 23.302 26.628 23.302 25.1562 22.0151V21.3332V18.5704H26.1873",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8084 11.7759V14.6961C31.8084 16.986 29.9342 18.9145 27.6445 18.8703C25.4255 18.8276 23.6406 17.0158 23.6406 14.7874V11.7759C23.6406 9.52082 25.4691 7.69238 27.7246 7.69238C29.9801 7.69238 31.8084 9.52082 31.8084 11.7759Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8516 12.359C27.5749 12.8664 29.0719 12.8435 30.603 12.2304C30.9384 12.0962 31.2531 11.9424 31.5417 11.7755",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 49.6621H44.4786",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 55.5234H44.4786",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 61.3809H44.4786",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 67.2383H44.4786",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 37.9473H44.4786",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 43.8047H44.4786",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.622 50.0039C6.81023 50.0039 6.96275 49.8513 6.96275 49.6633C6.96275 49.4755 6.81036 49.3228 6.622 49.3228C6.43356 49.3228 6.28125 49.4754 6.28125 49.6633C6.28125 49.8513 6.43369 50.0039 6.622 50.0039Z",
    fill: "#20ACE3",
    stroke: "#20ACE3",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.622 38.2871C6.81036 38.2871 6.96275 38.1345 6.96275 37.9467C6.96275 37.7586 6.8103 37.606 6.622 37.606C6.43362 37.606 6.28125 37.7585 6.28125 37.9467C6.28125 38.1345 6.43356 38.2871 6.622 38.2871Z",
    fill: "#20ACE3",
    stroke: "#20ACE3",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.622 44.1465C6.8103 44.1465 6.96275 43.9939 6.96275 43.8059C6.96275 43.6181 6.81036 43.4654 6.622 43.4654C6.43356 43.4654 6.28125 43.618 6.28125 43.8059C6.28125 43.994 6.43362 44.1465 6.622 44.1465Z",
    fill: "#20ACE3",
    stroke: "#20ACE3",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.622 55.8613C6.81036 55.8613 6.96275 55.7087 6.96275 55.5209C6.96275 55.3328 6.8103 55.1803 6.622 55.1803C6.43362 55.1803 6.28125 55.3328 6.28125 55.5209C6.28125 55.7088 6.43356 55.8613 6.622 55.8613Z",
    fill: "#20ACE3",
    stroke: "#20ACE3",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.622 61.7227C6.8103 61.7227 6.96275 61.5701 6.96275 61.3821C6.96275 61.1942 6.81036 61.0416 6.622 61.0416C6.43356 61.0416 6.28125 61.1942 6.28125 61.3821C6.28125 61.5702 6.43362 61.7227 6.622 61.7227Z",
    fill: "#20ACE3",
    stroke: "#20ACE3",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.622 67.5801C6.81023 67.5801 6.96275 67.4274 6.96275 67.2395C6.96275 67.0516 6.81036 66.899 6.622 66.899C6.43356 66.899 6.28125 67.0516 6.28125 67.2395C6.28125 67.4275 6.43369 67.5801 6.622 67.5801Z",
    fill: "#20ACE3",
    stroke: "#20ACE3",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4844 32.2957V49.5573C49.4844 50.0431 50.0427 50.315 50.4253 50.0155L54.1323 47.113C54.2371 47.0301 54.3649 46.9894 54.4916 46.9894C54.6181 46.9894 54.746 47.0301 54.8508 47.113L58.5578 50.0155C58.9402 50.315 59.5002 50.0431 59.5002 49.5573V32.7944",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8542 20.7094C68.8542 22.538 66.8116 23.9475 66.1523 25.5376C65.4686 27.186 65.8904 29.6206 64.6481 30.8628C63.4057 32.105 60.9708 31.6833 59.3223 32.3668C57.732 33.0262 56.3222 35.0684 54.4935 35.0684C52.6646 35.0684 51.2551 33.0262 49.6647 32.3668C48.0161 31.6831 45.5812 32.105 44.3388 30.8627C43.0965 29.6206 43.5183 27.186 42.8347 25.5376C42.1754 23.9475 40.1328 22.538 40.1328 20.7094C40.1328 18.8808 42.1754 17.4714 42.8347 15.8812C43.5183 14.2329 43.0965 11.7983 44.3389 10.556C45.5813 9.31384 48.0162 9.73557 49.6647 9.05206C51.2551 8.39259 52.6646 6.35046 54.4935 6.35046C56.3224 6.35046 57.732 8.39259 59.3223 9.05206C60.9708 9.73571 63.4058 9.31384 64.6481 10.5561C65.8905 11.7983 65.4686 14.2329 66.1523 15.8812C66.8116 17.4714 68.8542 18.8808 68.8542 20.7094Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7196 13.6194L57.0213 17.0571C57.059 17.1135 57.1156 17.1546 57.181 17.1731L61.1621 18.2995C61.3578 18.355 61.4347 18.5915 61.3088 18.7514L58.7502 22.0023C58.7082 22.0558 58.6868 22.1223 58.6893 22.1902L58.848 26.3239C58.8559 26.5275 58.6546 26.6735 58.4637 26.6032L54.5808 25.1749C54.5171 25.1515 54.4471 25.1515 54.3833 25.1749L50.5005 26.6032C50.3095 26.6735 50.1081 26.5275 50.1161 26.3239L50.2747 22.1902C50.2773 22.1223 50.2558 22.0558 50.2136 22.0023L47.6551 18.7514C47.5292 18.5915 47.6062 18.355 47.802 18.2995L51.783 17.1731C51.8485 17.1546 51.905 17.1135 51.9428 17.0571L54.2445 13.6194C54.3577 13.4503 54.6064 13.4503 54.7196 13.6194Z",
    stroke: "#20ACE3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/expertise.0ad3c664083b31d7801a2295caea83d7.svg";
export { ForwardRef as ReactComponent };